import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountVisibility from "./AbstractAccountVisibility.js";

/**
 * Setting to hide rows with no data in a report.
 */
class HideNoDataAccountsVisibility extends AbstractAccountVisibility {
	isVisible(row) {
		return row.hasDataOrHasChildWithData();
	}

	static getType() {
		return "nonempty";
	}

	static getLabel() {
		return _("Non-empty");
	}
}

export default HideNoDataAccountsVisibility;
